import { CoreModule } from '@admin/core/core.module';
import { environment } from '@admin/environments';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(CoreModule)
  .catch(err => console.error(err));
